import { Api } from '../api';
import { createUrl } from '../../helpers/uri-factory';

const url = createUrl('sumadi');

export class LaunchInstructor extends Api {
    constructor(http, config = {}) {
        super(http, url, 'launch-instructor', config);
    }
}